
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import ToggleChart from '../dashboard/toggleview.js';

import {
  Chart,
  ChartTitle,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesLabels,
  ChartSeriesItemTooltip
} from '@progress/kendo-react-charts';

const labelContent = (e) => (e.dataItem.share);

class KendoChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      //type: props.type || 'donut',
      isHovered: false,
      type: 'donut'
    }

  }

  donutCenterRenderer = () => {
    const { data } = this.props;
    let initialValue = 0;
    let total = data.reduce((accumulator, currentValue) => {
      let val = accumulator 
      let tempval = currentValue.share && (currentValue.kind === 'Paid' || currentValue.kind === 'Unpaid') ? currentValue.share : null
      return val + tempval
    }, initialValue)
    console.log(total)
    return <h6>{total}</h6>
  };

  setType = (type) => {
    this.setState({ type: type })
  }

  render() {
    return (
      <Fragment>
        {this.props.showToggles && <ToggleChart handleToggleView={(type) => this.setType(type)} type={this.state.type} />}
        <Chart donutCenterRender={this.donutCenterRenderer} style={{height: 'calc(51vh - 130px)'}}>
          <ChartTitle text={this.props.monthName} color="white" background="black" font="15pt" />
          <ChartSeries>
            <ChartSeriesItem type={this.state.type || 'donut'} data={this.props.data} categoryField="kind" field="share" >
              <ChartSeriesLabels color="#fff" background="none" content={labelContent} />

            </ChartSeriesItem>
          </ChartSeries>
          <ChartLegend visible={true} position="bottom" orientation="horizontal"/>
        </Chart>
      </Fragment>
    )
  }
}
//position="bottom" orientation="horizontal"
export default KendoChart
